import { Injectable } from '@angular/core';
import { SessionService } from '@services/utils/session.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppLoadedService {
    private appLoadedSubject = new BehaviorSubject<boolean>(this.sessionService.getIsLoaded());

    readonly appLoaded = this.appLoadedSubject.asObservable();

    constructor(private sessionService: SessionService) { }

    load(): void {
        this.appLoadedSubject.next(true);
        this.sessionService.setIsLoaded(true);
    }

    unload(): void {
        this.appLoadedSubject.next(false);
        this.sessionService.setIsLoaded(false);
    }
}
